import { gql } from '@apollo/client';

const AuditCompanyQuery = gql`
  query AuditCompanyQuery($companyName: String, $phoneNumber: String, $postCode: String) {
    auditCompany(companyName: $companyName, phoneNumber: $phoneNumber, postCode: $postCode) {
      jobId
      message
      status
      success
    }
  }
`;

const FetchAuditQuery = gql`
  query FetchAuditQuery($jobId: String!) {
    fetchAudit(jobId: $jobId) {
      auditSources {
        address
        companyName
        sourceName
        url
      }
      state
      status
      success
    }
  }
`;

const LeadQuery = gql`
  query LeadQuery($leadToken: String!) {
    lead(leadToken: $leadToken) {
      address
      aggregateScore
      companyName
      email
      highestScoreSource {
        address
        averageRating
        companyName
        phoneNumber
        ratingDistribution
        reviewCount
        sourceName
        url
      }
      logo
      lowestScoreSource {
        address
        averageRating
        companyName
        phoneNumber
        ratingDistribution
        reviewCount
        sourceName
        url
      }
      totalNumberOfReviews
      sources {
        address
        averageRating
        companyName
        phoneNumber
        ratingDistribution
        reviewCount
        sourceName
        url
      }
      sentiment {
        negative
        neutral
        positive
      }
    }
  }
`;

const LeadPollingQuery = gql`
  query LeadPollingQuery($leadToken: String!) {
    lead(leadToken: $leadToken) {
      sources {
        sourceName
      }
    }
  }
`;

const ReviewWidgetQuery = gql`
  query ReviewWidgetQuery($token: String!, $cursor: String) {
    reviewWidget(token: $token) {
      colors
      customCss
      displayElements {
        date
        image
        name
        rating
        text
        quote
      }
      displayMode
      fonts
      id
      locale
      name
      position
      showOnMobile
      waitingTime
      widgetType
      richSnippet
      brandingName
      brandingLogo
      businessName
      reviewConnection(first: 8, after: $cursor) {
        nodes {
          id
          date
          organizationId
          posterUrl
          rating
          reviewSource {
            id
            sourcePic
            url
          }
          reviewUrl
          text
          userName
          userPic
          videoUrl
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      reviewSummary {
        averageRating
        count
        reviewSources {
          availableSourceId
          id
          name
          sourcePic
          url
        }
      }
    }
  }
`;

const ReviewConnectionQuery = gql`
  query ReviewConnectionQuery($token: String!, $cursor: String) {
    reviewWidget(token: $token) {
      id
      reviewConnection(first: 8, after: $cursor) {
        nodes {
          id
          date
          organizationId
          posterUrl
          rating
          reviewSource {
            id
            sourcePic
            url
          }
          reviewUrl
          text
          userName
          userPic
          videoUrl
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`;

export {
  AuditCompanyQuery,
  FetchAuditQuery,
  LeadQuery,
  LeadPollingQuery,
  ReviewWidgetQuery,
  ReviewConnectionQuery,
};
